export const SHADOW_HOST_ID = 'shadow-host';
export const shadowRoot = () =>
  document.getElementById(SHADOW_HOST_ID)?.shadowRoot;

export const SHADOW_APP_ID = 'shadow-app';
export const shadowApp = () => shadowRoot()?.getElementById(SHADOW_APP_ID);

export const SHADOW_APP_PORTAL_ID = 'shadow-app-sibling';
/**
 * Modals and popovers go into this element. For accessibility reasons
 * the modals should not "portal" into the app itself but into
 * a sibling according to react-modal:
 * @see https://reactcommunity.org/react-modal/#using-a-custom-parent-node
 */
export const shadowAppPortal = () =>
  shadowRoot()?.getElementById(SHADOW_APP_PORTAL_ID);
